export const buildParticipantInvitationLink = ({
    origin = window.location.origin,
    pathname = window.location.pathname,
} = {}) => {
    const segments = pathname.split('/').filter(Boolean);
    const moderatorIndex = segments.lastIndexOf('moderator');
    const clientPath =
        moderatorIndex >= 0 ? segments.slice(0, moderatorIndex) : segments.slice(0, -1);
    const participantPath = `/${[...clientPath, 'input'].join('/')}`;

    return new URL(participantPath, origin).toString();
};
